<template>
<div class="homeConfig">
  <homeView v-if="homeShow" @homeShows="homeShows" @showClose="showClose"></homeView>
  <div v-else class="mainContent" :style="styleObject">
    <div class="handles">
      <handles1>
        <template v-slot:right>
          <!-- <div><button @click="tiao">tiao</button></div> -->
          <button class="primaryBtn" @click="seeView">预览</button>
        </template>
      </handles1>
    </div>
    <div class="tableBox1">
      <div class="header">
        <span class="text">首页背景选择</span>
        <span class="line">
          <span></span>
        </span>
      </div>
      <div class="bodyy">
        <div class="left">
          <el-radio-group v-model="mapType">
            <el-radio :label=1>地图</el-radio>
            <img src="@/assets/img/use/homeConfig/bgmap1.png" title="地图">
            <el-radio :label=2 style="margin-left:50px">卫星图</el-radio>
            <img src="@/assets/img/use/homeConfig/bgmap2.png" title="卫星图">
          </el-radio-group>
        </div>
      </div>
      <div class="header">
        <span class="text">首页面板配置<span style="font-size:12px">(请选择6项)</span></span>
        <span class="line">
          <span></span>
        </span>
      </div>
      <div class="items">
        <el-checkbox-group v-model="checkedItems" @change="handleCheckedItemsChange">
          <div class="allItem">
            <div class="item" v-for="(item,i) in allConfig" :key="i">
              <el-checkbox :label="item.id">
                <span class="top">{{item.name}}</span>
                <br />
                <span class="bottom">{{item.remark}}</span>
              </el-checkbox>
              <span class="img"><img :src="require(`@/assets/img/use/homeConfig/${item.imgName}.png`)" title=""></span>
            </div>
           <!--  <div class="item lastItem" @click="openDrawer">
              <i class="el-icon-circle-plus-outline"></i>
            </div> -->
          </div>
        </el-checkbox-group>
      </div>
      <div>
      </div>
    </div>
  </div>
  <!-- <el-drawer :title="drawer.title" :size="drawer.wid" :modal="false" :visible.sync="drawer.show" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
    <add-module v-if="drawer.show" :drawer="drawer" @formSubmit="formSubmit" :loading.sync="drawer.loading" @confirm="handleConfirm" @cancel="handleCancel"></add-module>
  </el-drawer> -->
</div>
</template>

<script>
import handles1 from "@/components/common/Handles1";
import homeView from '@/components/systemMange/HomeView.vue';
// import AddModule from '@/components/systemMange/AddModule.vue'
export default {
  components:{
    handles1,
    homeView,
    // AddModule
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      // =======
      mapType: 1,
      checkedItems: [],
      allConfig: [],
      chooseConfig: [],
      homeShow:false,
      //   drawer: {
      //   title: '',
      //   wid: '500px',
      //   show: false,
      //   loading: false,
      //   rowData: [],
      //   type: ''
      // },
    }
  },
  created() {
    this.makeheight()
    this.init()
  },
  methods: {
    showClose(){
      this.homeShow = false
    },
    homeShows(data){
      this.homeShow=data
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    init() {
      this.getAllConfig();
      this.getChooseConfig()
      this.getMapType()
      this.storage.setSession("mapType", this.mapType)
    },
    async getAllConfig() {
      const {
        code,
        msg,
        data
      } = await this.request.get('/front/homepage/findAllTemplate')
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
      }
      this.allConfig = data
      this.storage.setSession("allConfig", JSON.stringify(data))
    },
    async getChooseConfig() {
      const {
        code,
        msg,
        data
      } = await this.request.get('/front/homepage/findTemplateByIds')
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.checkedItems = data.map(item => item.id)
      this.chooseConfig = data
      this.storage.setSession("checkedItems", JSON.stringify(this.checkedItems))

    },
    async getMapType(){
      const {code,msg,data:{mapType}} = await this.request.get('/front/homepage/findTenantConfig')
      if(code!==200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.mapType = mapType
    },
   
    seeView() {
      if (this.checkedItems.length !== 6) {
        return this.$message.warning('请选择6项后重试')
      }
      this.storage.setSession("mapType", this.mapType)
      // this.$router.push('/homeView')
      this.homeShow=true
    },
    handleCheckedItemsChange() {
      //console.log(`this.checkedItems`, this.checkedItems)
      this.storage.setSession("checkedItems", JSON.stringify(this.checkedItems))
    },
    tiao(){
      this.$router.push({
        path: "/cardManagement",
      });
    }
    //  openDrawer() {
    //   this.drawer.show = true
    // },
    // async formSubmit(row) {
    //   const {
    //     code
    //   } = await this.request.post('/front/homepage/addTemplate', row)
    //   this.drawer.show = false
    //   if (code !== 200) {
    //     return
    //   }
    //   this.getChooseConfig()
    //   return this.$message.success('添加成功')
    // },
   /*  closeMess() {
      this.drawer.loading = false;
    },
    handleConfirm() { //确认
      this.drawer.show = false
    },
    handleCancel() { //取消
      this.drawer.show = false
    }, */
  },
}
</script>

<style lang="scss">
.homeConfig {
  // height: 100%;
  // .mainContent {
  //   width: 100%;
  //   height: 100%;
  //   box-sizing: border-box;
  //   margin: 12px;
  //   background-color: #fff !important;
  // }

  .handles {
    height: 100px;
  }
  .tableBox1 {
    box-sizing: border-box;
    width: 100%;
    height: 80%;
    padding: 0 22px 120px 22px !important;
    background-color: #fff;
    overflow-y: auto;
  }
  width: 100%;
  height: 100vh;

  .mainContent {
    width: 100%;
    height: 100%;

    .tableBox1 {
      display: flex;
      flex-direction: column;

      .header {
        display: flex;
        height: 44px;

        .text {
          height: 44px;
          line-height: 44px;
          font-size: 20px;
          color: #333;
          font-weight: 100;
          padding-left: 50px;
        }

        .line {
          flex: 1;
          height: 44px;
          line-height: 44px;
          display: flex;
          align-items: center;

          span {
            flex: 1;
            width: 100%;
            height: 1px;
            background-color: #ccc;
          }
        }
      }

      .bodyy {
        height: 100px;
        line-height: 100px;
        display: flex;

        .left {
          .el-radio__inner {
            width: 20px;
            height: 20px;
            font-size: 20px;
            border: 1px solid #333;
          }

          .el-radio__inner::after {
            width: 8px;
            height: 8px;
          }
        }
      }

      .items {
        flex: 1;

        .el-checkbox-group {
          height: 80%;

          .allItem {
            display: flex;
            height: 100%;
            // align-content: space-between;
            justify-content: flex-start;
            flex-flow: row wrap;
            // padding-bottom: 100px;

            .item {
              // display: block;
              // margin-left: 25px;
              // width: 240px;
              // height: 275px;
              // background-color: #fff;
              // font: 600 12px/1 arial;
              // color: #555;
              // text-align: center;
              // background-color: pink;
              width: 20%;
              height: 50%;
              box-sizing: border-box;
              display: flex;
              border-right: 10px solid #f0f4fa;
              border-bottom: 10px solid #f0f4fa;
              flex-direction: column;
              padding: 10px;
              // margin: 0 auto;
              // justify-content: center;
              align-items: center;
              overflow: hidden;

              .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #606266;
              }

              .el-checkbox {
                width: 50%;
                position: relative;

                .el-checkbox__inner {
                  position: absolute;
                  top: -20px;
                  left: -20px;
                  width: 20px;
                  height: 20px;
                  font-size: 20px;
                  border: 1px solid #333;

                }

                .el-checkbox__inner::after {
                  width: 8px;
                  height: 8px;
                }

              }

              .top {
                color: black;
                text-align: center;
              }

              .img {
                border-radius: 5px;
                overflow: hidden;
                background-color: #0C1A35;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

            }

            .item:hover {
              transition: all .3s;
              transform: translateY(-5px);
              box-shadow: 0 20px 50px #ddd;
            }
          }
        }

      }
    }
  }
}
</style>
